//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SysMessageModal from "./modules/SysMessageModal";
import { doReleaseData, doReovkeData } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: "SysAnnouncementList",
  mixins: [JeecgListMixin],
  components: {
    SysMessageModal: SysMessageModal
  },
  data: function data() {
    return {
      description: '系统通告表管理页面',
      // 查询条件
      queryParam: {},
      // 表头
      columns: [{
        title: '#',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '标题',
        align: "center",
        dataIndex: 'titile'
      }, {
        title: '消息类型',
        align: "center",
        dataIndex: 'msgCategory',
        customRender: function customRender(text) {
          if (text == '1') {
            return "通知公告";
          } else if (text == "2") {
            return "系统消息";
          } else {
            return text;
          }
        }
      },
      /*{
        title: '开始时间',
        align: "center",
        dataIndex: 'startTime'
      },
      {
        title: '结束时间',
        align: "center",
        dataIndex: 'endTime'
      },*/
      {
        title: '发布人',
        align: "center",
        dataIndex: 'sender_userName'
      }, {
        title: '优先级',
        align: "center",
        dataIndex: 'priority',
        customRender: function customRender(text) {
          if (text == 'L') {
            return "低";
          } else if (text == "M") {
            return "中";
          } else if (text == "H") {
            return "高";
          } else {
            return text;
          }
        }
      }, {
        title: '通告对象',
        align: "center",
        dataIndex: 'msgType',
        customRender: function customRender(text) {
          if (text == 'USER') {
            return "指定用户";
          } else if (text == "ALL") {
            return "全体用户";
          } else {
            return text;
          }
        }
      }, {
        title: '发布状态',
        align: "center",
        dataIndex: 'sendStatus',
        customRender: function customRender(text) {
          if (text == 0) {
            return "未发布";
          } else if (text == 1) {
            return "已发布";
          } else if (text == 2) {
            return "已撤销";
          } else {
            return text;
          }
        }
      }, {
        title: '发布时间',
        align: "center",
        dataIndex: 'sendTime'
      }, {
        title: '撤销时间',
        align: "center",
        dataIndex: 'cancelTime'
      },
      /*{
            title: '删除状态（0，正常，1已删除）',
            align:"center",
            dataIndex: 'delFlag'
          },*/
      {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: "/sys/annountCement/list",
        delete: "/sys/annountCement/delete",
        deleteBatch: "/sys/annountCement/deleteBatch",
        releaseDataUrl: "/sys/annountCement/doReleaseData",
        reovkeDataUrl: "sys/annountCement/doReovkeData",
        exportXlsUrl: "sys/annountCement/exportXls",
        importExcelUrl: "sys/annountCement/importExcel"
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    loadData: function loadData(arg) {
      this.queryParam.msgCategory = "2";
      this.initTableData(arg);
    },
    //执行发布操作
    releaseData: function releaseData(id) {
      console.log(id);
      var that = this;
      doReleaseData({
        id: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData(1);
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    //执行撤销操作
    reovkeData: function reovkeData(id) {
      var that = this;
      doReovkeData({
        id: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData(1);
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    }
  }
};